document.addEventListener('DOMContentLoaded', () => {
  document.addEventListener('submit', function (e: SubmitEvent) {
    const form = e.target as HTMLFormElement;
    if (!(form instanceof HTMLFormElement)) return;

    const isMainForm = form.parentElement?.tagName === 'MAIN';
    const isModalForm = form.parentElement?.classList.contains('modal-content');

    if (!isMainForm && !isModalForm) return;
    
    const $form = $(form);
    if (!$form.valid()) {
      return;
    }

    const button = e.submitter as HTMLButtonElement | null;

    if (form.dataset.submitting === 'true') {
      e.preventDefault();
      alert('Your form is already being submitted. Just hang tight for a moment!');
      return;
    }

    if (button?.type === 'submit') {
      form.dataset.submitting = 'true';

      // Disable button immediately
      requestAnimationFrame(() => {
        button.disabled = true;
      });

      // Show spinner only after a short delay (if form hasn't completed yet)
      window.setTimeout(() => {
        const spinner = document.createElement('i');
        spinner.className = 'fas fa-spinner fa-spin me-1';
        button.insertBefore(spinner, button.firstChild);
      }, 300);
    }
  });
});
